import React, { Component } from 'react'
import IosInstallSteps from './IosInstallSteps'

class PromoteDownload extends Component {
	constructor(props) {
		super(props)
		this.state = {
			show_ios_steps: false,
			closing: false
		}
		this.cardRef = React.createRef()
	}

	//fondu + repli de hauteur, puis l'action réelle (le retrait vient du re-rendu parent)
	_collapse = (after) => {
		const el = this.cardRef.current
		const reduce = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? true : false
		if (el === null || reduce === true)
		{
			if (after)
				after()
			return ;
		}
		el.style.height = el.offsetHeight + 'px'
		el.style.overflow = 'hidden'
		void el.offsetHeight //fige la hauteur avant de lancer la transition
		el.style.transition = 'opacity 180ms ease, height 260ms ease 100ms, padding-top 260ms ease 100ms, padding-bottom 260ms ease 100ms'
		el.style.opacity = '0'
		el.style.height = '0px'
		el.style.paddingTop = '0px'
		el.style.paddingBottom = '0px'
		this.setState({ closing: true })
		if (after)
			setTimeout(after, 400)
	}

	clickLater = () => {
		if (this.state.closing === true)
			return ;
		this._collapse(this.props.btnLater)
	}

	clickInstall = () => {
		if (this.state.closing === true)
			return ;
		//iOS ne sait pas déclencher l'invite native : on affiche le mode d'emploi
		if (this.props.ios === true)
		{
			this.setState({ show_ios_steps: true })
			return ;
		}
		//l'invite native doit partir dans le geste utilisateur : action d'abord, repli ensuite
		this.props.btnInstall()
		this._collapse(null)
	}

	render() {
		const home = this.props.lang_assets.home
		let content = null
		let buttons = null
		if (this.state.show_ios_steps === true)
		{
			content = (<IosInstallSteps lang_assets={this.props.lang_assets} />)
			buttons = (
				<button
					type="button"
					onClick={this.clickLater}
					className="rounded-md text-base font-medium text-blue-600 hover:text-sky-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
				>
					{home.understood}
				</button>
			)
		}
		else
		{
			content = (<p className="dl-content text-gray-700 mt-2">{home.promote_install}</p>)
			buttons = (
				<React.Fragment>
					<button
						type="button"
						onClick={this.clickLater}
						className="rounded-md text-base font-normal text-gray-600 text-opacity-50 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
					>
						{home.later}
					</button>
					<button
						type="button"
						onClick={this.clickInstall}
						className="rounded-md text-base font-medium text-blue-600 hover:text-sky-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
					>
						{home.install}
					</button>
				</React.Fragment>
			)
		}
		return (
			<div ref={this.cardRef} className="w-11/12 p-5 text-base mx-auto rounded-xl bg-blue-100 shadow">
				<p className="font-semibold text-gray-700">{home.full_experience} <span role="img" aria-label="mobile phone with arrow">📲</span></p>
				{content}
				<div className="btn-container mt-2">
					<div className="mt-3 flex space-x-7">
						{buttons}
					</div>
				</div>
			</div>
		)
	}
}

export default PromoteDownload
